import { getAppConfig } from "../hooks/useAppConfig";

const SERVER = getAppConfig("server");
export function url(path) {
  return `${SERVER}${path}`;
}
